<template>
  <svg role="img" class="icon" :class="cssClass"><use :xlink:href="href"></use></svg>
</template>

<script>
export default {
  props: ['icon'],
  computed: {
    href() {
      const path = process.env.NODE_ENV === 'production' ? `/SPA/dist/` : ''
      return `${path}/icons.svg#${this.icon}`
    },
    cssClass() {
      return `icon--${this.icon}`
    }
  }
}
</script>
